import axios from "axios";
import CustomBlockButton from "../../../components/button/CustomBlockButton";
import { useApiInfoContextValueHook } from "../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../utils/sellertool-signature-utils";
import { CustomLabelInput } from "../../../components/input/CustomLabelInput";
import { useState } from "react";
import styled from 'styled-components';

export function MainView(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const [formData, setFormData] = useState({
        orderNumber1: '',
        returnExchangeQuantity: '1',
        returnExchangeType: 'EXCHANGE',
        returnExchangeProceedStatus: 'PROCESSING_COMPLETE',
    })

    const handleReqFetchErpItems = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: [
                {
                    orderNumber1: formData.orderNumber1,
                    returnExchangeQuantity: formData.returnExchangeQuantity,
                    returnExchangeType: formData.returnExchangeType,
                    returnExchangeProceedStatus: formData.returnExchangeProceedStatus,
                }
            ]
        }

        const response = await axios.post('http://localhost:7071/api/return-exchanges/from-system', body, {
            headers: headers,
        })

        console.log(response);
    }

    return (
        <>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                    onChange={(e) => setFormData({ ...formData, orderNumber1: e.target.value })}
                    value={formData.orderNumber1 || ''}
                />
                <CustomLabelInput.Label style={{ color: 'var(--redColor1)' }}>*주문번호1</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='number'
                    onChange={(e) => setFormData({ ...formData, returnExchangeQuantity: e.target.value })}
                    value={formData.returnExchangeQuantity || ''}

                />
                <CustomLabelInput.Label style={{ color: 'var(--redColor1)' }}>*반품/교환 수량</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                    onChange={(e) => setFormData({ ...formData, returnExchangeType: e.target.value })}
                    value={formData.returnExchangeType || ''}
                />
                <CustomLabelInput.Label style={{ color: 'var(--redColor1)' }}>*반품/교환 타입</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                    onChange={(e) => setFormData({ ...formData, returnExchangeProceedStatus: e.target.value })}
                    value={formData.returnExchangeProceedStatus || ''}
                />
                <CustomLabelInput.Label style={{ color: 'var(--redColor1)' }}>*진행상태</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>회수운송장번호</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>배송비 지불방식</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>고객요청 수거방식</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>시스템 클레임</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>고객 클레임</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='number'
                />
                <CustomLabelInput.Label>반품/교환 배송비</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='number'
                />
                <CustomLabelInput.Label>반품/교환 기타비용</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>반품/교환 메모1</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>반품/교환 메모2</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 옵션코드</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='number'
                />
                <CustomLabelInput.Label>교환출고 수량</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 운송장번호</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 주소</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 주소상세</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 수취인명</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 수취인 연락처1</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>교환출고 수취인 연락처2</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='number'
                />
                <CustomLabelInput.Label>교환출고 배송비</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomLabelInput>
                <CustomLabelInput.Input
                    type='text'
                />
                <CustomLabelInput.Label>보관함 ID</CustomLabelInput.Label>
            </CustomLabelInput>
            <CustomBlockButton
                type='button'
                onClick={() => handleReqFetchErpItems()}
            >erp item 조회</CustomBlockButton>
        </>
    );
}